import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, ButtonGroup, Tooltip } from "reactstrap";
import projActions from "../../../_actions/projActions";
import _ from "lodash";
import TitleBar from "../../_common/TitleBar";
import Table from "../../_common/Table";
import Select from "react-select";
import "./styles/projList.css";
// import "react-block-ui/style.css";
import "loaders.css/loaders.min.css";
import { actionScripts } from "../../../_helpers/actionScripts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlertModal from "../../_common/AlertModal";
import mainTabActions from "../../../_actions/mainTabActions";
import { DOCTYPE } from "../../../_constants/docTypeConstants";
import { docPermConstants } from "../../../_constants/permissionConstants";
import { getPermissions } from "../../../_helpers/authorize";


const FavoriteButton = ({ projectId, isActive, onClick, toolTipId, setToolTipId }) => {
  const [isHovered, setHovered] = React.useState(false);
  const iconType = (isHovered || isActive) ? "fas" : "far";
  const iconColor = (isHovered || isActive) ? "text-warning" : "text-dark";
  return(
    <>
      <button
        type="button"
        id={`favoriteBtn-${projectId}`}
        name="userFav"
        className="btn btn-sm my-auto user-fav-btn"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={onClick}
      >
        <FontAwesomeIcon 
          icon={[iconType, "star"]} 
          style={{fontSize: "1.2rem"}} 
          className={`fa-fw ${iconColor}`}
        />
      </button>
      <Tooltip
        placement="top"
        className="proj-tooltip"
        isOpen={toolTipId === `favoriteBtn-${projectId}`}
        target={`favoriteBtn-${projectId}`}
        toggle={() => setToolTipId(`favoriteBtn-${projectId}`)}
      >
        Mark As Favorite
      </Tooltip>
    </>
  );
};

class ProjList extends Component {
  state = {
    districtFilter: "",
    myProjFilter: false,
    proDmsOnlyFilter: false,
    eaFilter: "",
    statusFilter: { value: "ALL", label: "Status: All" },
    sortColumn: { path: "fullEA", order: "asc" },
    showAlert_addToProDMS: false,
    showAlert_projNotAvail: false,
    showAlert_contactDistAdmin: false,
    permissions: null,
  };

  selectedProjectId = 0;

  columns = [
    /*
    {
      path: "userFavorite",
      thClassName: "projList-table__th--icon",
      tdClassName: "projList-table__td--icon",
      content: (proj) => (
        <FavoriteButton
          projectId = {proj.projectId}
          isActive={proj.userFavorite}
          onClick={e => {
            proj.userFavorite = !proj.userFavorite;
            e.stopPropagation();
            this.setState({ userFavorite: !this.state.userFavorite });
          }}
          toolTipId={this.state.toolTipId}
          setToolTipId={id => 
            this.setState({toolTipId: this.state.toolTipId === id ? null : id})}
        />
      ),
    },
    */ 
    {
      path: "fullEA",
      label: "EA",
      content: (proj) => this.renderEa(proj),
      thClassName: "projList-table__th--ea",
      tdClassName: "projList-table__td--ea",
    },
    {
      path: "coRtePm",
      label: "Co-Rte-PM",
      thClassName: "projList-table__th--loc",
      tdClassName: "projList-table__td--loc",
    },
    {
      path: "workDescription",
      label: "Description",
      thClassName: "projList-table__th--desc",
      tdClassName: "projList-table__th--desc",
    },
    {
      path: "projectStatus",
      label: "Status",
      disableSort: true,
      content: (proj) => this.renderProjectStatus(proj.projectStatus),
      thClassName: "projList-table__th--status",
      thClassName: "projList-table__td--status",
    },
    {
      path: "summary",
      label: "",
      disableSort: true,
      thClassName: "projList-table__th--summary",
      thClassName: "projList-table__td--summary",
      content: (proj) =>
        proj.isProDMSProject && (
          <div className="my-auto float-right">
            <span className={proj.unitCount === 0 ? "text-danger" : ""}>
              <b>Units: </b>
              {proj.unitCount},
            </span>
            <span className="ml-1">
              <b>Staff: </b>
              {proj.staffCount}
            </span>
          </div>
        ),
    },
    {
      path: "projectAdmin",
      disableSort: true,
      thClassName: "text-left projList-table__th--icon",
      tdClassName: "text-left projList-table__td--icon",
      content: (proj) => (
        <>
          <button
            type="button"
            id={`projAdminBtn-${proj.projectId}`}
            name="projAdmin"
            className="btn btn-outline-dark btn-sm my-auto modern-btn"
            onClick={(e) => {
              e.stopPropagation();
              actionScripts.OPEN_PROJ_ADMIN.run(proj.projectId);
            }}
          >
            <FontAwesomeIcon icon="tools" className="fa-fw" />
          </button>
          <Tooltip
            placement="top"
            className="proj-tooltip"
            isOpen={this.state.toolTipId === `projAdminBtn-${proj.projectId}`}
            target={`projAdminBtn-${proj.projectId}`}
            toggle={() => this.setState({ toolTipId: this.state.toolTipId === `projAdminBtn-${proj.projectId}` ? null : `projAdminBtn-${proj.projectId}` })}
          >
            Project Admin
          </Tooltip>
        </>
      )
    },
    {
      path: "projectReports",
      disableSort: true,
      
      thClassName: "text-left projList-table__th--icon",
      tdClassName: "text-left projList-table__td--icon",
      content: (proj) => (
        <>
          <button
            type="button"
            id={`projReportBtn-${proj.projectId}`}
            name="adrList"
            className="btn btn-outline-dark btn-sm my-auto modern-btn"
            onClick={(e) => {
              e.stopPropagation();
              actionScripts.OPEN_ADR_LIST.run(proj.projectId);
            }}
          >
            <FontAwesomeIcon icon="file" className="fa-fw" />
          </button>
          <Tooltip
            placement="top"
            className="proj-tooltip"
            isOpen={this.state.toolTipId === `projReportBtn-${proj.projectId}`}
            target={`projReportBtn-${proj.projectId}`}
            toggle={() => this.setState({ toolTipId: this.state.toolTipId === `projReportBtn-${proj.projectId}` ? null : `projReportBtn-${proj.projectId}` })}
          >
            Daily Report List
          </Tooltip>
        </>
      )
    },
  ];

  statusOptions = [
    { value: "ALL", label: "Status: All" },
    { value: "ADVERTISED", label: "Advertised" },
    { value: "PRE_CONST", label: "Pre-Const" },
    { value: "IN_CONST", label: "In-Const" },
    { value: "POST_CONST", label: "Post-Const" },
  ];

  componentDidMount() {
    const { user, tab } = this.props;
    this.setState({
      permissions: getPermissions({
        user,
        docType: DOCTYPE.PROJECT_LIST,
        projectId: tab.projectId,
        creatorId: null,
      }),
    });
  }

  handleSort = (sortColumn) => this.setState({ sortColumn });
  //handleSort = (newSort) => this.setState(oldSort => ({ sortColumn: [newSort, ...oldSort.sortColumn.slice(1)] }));

  handleChange_stringFilter = (e) => this.setState({ [e.target.name]: e.target.value });

  handleChange_selectFilter = (fieldName) => (selectedOption) =>
    this.setState({ [fieldName]: selectedOption });

  handleClick_clearFilters = (e) => {
    e.preventDefault();
    this.setState({
      eaFilter: "",
      statusFilter: null,
    });
  };

  handleClick_districtFilter = (e) => {
    e.preventDefault();
    const { dispatch, tab } = this.props;
    const { proDmsOnlyFilter } = this.state;

    const district = +e.target.name.substring(1);
    const filters = {
      projectId: null,
      district,
      unitId: null,
      userId: null,
      proDMSProjectsOnly: proDmsOnlyFilter,
      ea: "",
    };
    dispatch(mainTabActions.changeMetadata(tab.tabId, { metadata: { dist: district } }));
    dispatch(projActions.fetchAllByFilter(filters, tab.tabId));
    this.setState({ districtFilter: e.target.name });
  };

  handleClick_myProjFilter = (e) => {
    e.preventDefault();
    this.setState({ myProjFilter: !this.state.myProjFilter });
  };

  handleClick_proDmsOnlyFilter = (e) => {
    e.preventDefault();
    this.setState({ proDmsOnlyFilter: !this.state.proDmsOnlyFilter });
  };

  // Click on a project to open ProjSetup
  handleClick_projectListTr = (selectedProject) => {
    const { appSettings } = this.props;
    const { districtFilter, permissions } = this.state;
    const dist = +districtFilter.substring(1);

    let isDisabled = true; // Block by default

    // Detect appSettings
    const distIsPartOfImplementationProgram =
      appSettings.implementationProgram.districts.includes(dist);
    const projectIsPartOfImplementationProgram =
      appSettings.implementationProgram.projects.includes(selectedProject.projectId);

    // Captures all projects in pilot prior to 5/13/22. Not used.
    // const projectIsAzurePilotProject =
    //   selectedProject.projectId <=
    //   appSettings.implementationProgram.lastAzurePilotProjectId;

    // Allow access only if:
    // - On Azure, for non-implementation projects.
    // - On CT, for implementation projects (whether it's a current Azure pilot or not), or
    //   if the district is taken off of the implementation program.
    // - On Local, modify conditions as needed. You can enable all, or create a test condition
    //   for debugging purposes.
    if (
      (appSettings.environmentContext === "Azure" &&
        !projectIsPartOfImplementationProgram) ||
      (["CT", "CT_UAT"].includes(appSettings.environmentContext) &&
        (!distIsPartOfImplementationProgram || projectIsPartOfImplementationProgram)) ||
      ["Local", "Local_SSO"].includes(appSettings.environmentContext)
    )
      isDisabled = false;

    if (!isDisabled) {
      this.selectedProjectId = selectedProject.projectId;
      if (selectedProject.isProDMSProject)
        actionScripts.OPEN_PROJ_DASH.run(selectedProject.projectId);
      else {
        // If distAdmin, allow project initiation.
        if (permissions.includes(docPermConstants.EDIT_LEVEL_2))
          this.toggleAlert_addToProDMS();
        else this.toggleAlert_contactDistAdmin();
      }
    } else this.toggleAlert_projNotAvail();
  };

  handleAlert_addToProDMS = (alertAction) => async (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    const { districtFilter } = this.state;
    if (alertAction === "accept") {
      const dist = +districtFilter.substring(1);
      await dispatch(projActions.activate(this.selectedProjectId, dist));

      // Re-fetch fresh list for all other ProjectList tabs that are open
      dispatch(projActions.refetchAllOpenProjectLists(dist));
    }
    this.toggleAlert_addToProDMS();
  };

  toggleAlert_addToProDMS = () =>
    this.setState({ showAlert_addToProDMS: !this.state.showAlert_addToProDMS });

  toggleAlert_projNotAvail = () =>
    this.setState({ showAlert_projNotAvail: !this.state.showAlert_projNotAvail });

  toggleAlert_contactDistAdmin = () =>
    this.setState({ showAlert_contactDistAdmin: !this.state.showAlert_contactDistAdmin });

  getData = (options = {}) => {
    const { appSettings, projectList, currUserProjects, projRoleOptions } = this.props;
    const { sortColumn, eaFilter, statusFilter, myProjFilter : myProjFilterHome } = this.state;

    const myProjFilter = options.myProjFilter !== undefined ? options.myProjFilter : myProjFilterHome;

    //console.log(currUserProjects);
    //console.log(projRoleOptions);

    // For Azure environment, only show projects that are in pilot as of 5/13/22.
    // Otherwise, show all (but the pilot projects will be inaccessible in non-Azure
    // environments.)
    const envContext = appSettings.environmentContext;
    // const filteredByEnv = (projectList || []).filter((p) =>
    //   envContext === "Azure" ? p.projectId <= 106 : true
    // );
    const filteredByEnv = projectList || [];

    const filteredByEa =
      eaFilter !== ""
        ? filteredByEnv.filter((p) =>
            p.fullEA.toLowerCase().includes(eaFilter.trim().toLowerCase())
          )
        : filteredByEnv;
    const filteredByStatus =
      statusFilter !== null && statusFilter.value !== "ALL"
        ? filteredByEa.filter((p) => p.projectStatus === statusFilter.value)
        : filteredByEa;
    const filterMyProjects = myProjFilter
      ? filteredByStatus.filter((p) =>
          currUserProjects.map((up) => up.projectId).includes(p.projectId)
        )
      : filteredByStatus;
    return _.orderBy(filterMyProjects, [sortColumn.path], [sortColumn.order]);
  };

  renderEa = (proj) => {
    return proj.isProDMSProject ? (
      <div className="d-flex flex-row flex-wrap">
        <div className="mr-2">
          <b>{proj.fullEA}</b>
        </div>
        <div>
          <span className="span-bubble p-1 bg-dark">
            ProDMS
            <FontAwesomeIcon icon="check" className="fa-fw ml-1" />
          </span>
        </div>
      </div>
    ) : (
      proj.fullEA
    );
  };

  renderProjectStatus = (status) => {
    let statusCaption = "";
    let statusClass = "";
    switch (status) {
      case "ADVERTISED":
        statusCaption = "Advertised";
        statusClass = "secondary";
        break;
      case "PRE_CONST":
        statusCaption = "Pre-Const";
        statusClass = "warning";
        break;
      case "IN_CONST":
        statusCaption = "In-Const";
        statusClass = "success";
        break;
      case "POST_CONST":
        statusCaption = "Post-Const";
        statusClass = "info";
        break;
      default:
        break;
    }
    statusClass = "span-bubble p-1 bg-" + statusClass;
    return <span className={statusClass}>{statusCaption}</span>;
  };

  renderUserRole = (role) => {

  };

  renderFilters = () => {
    const { districtFilter } = this.state;
    return (
      <div className="card mx-2">
        <div className="card-body bg-lightgray p-3">
          <div className="form-row form-group form-inline mb-0">
            <ButtonGroup className="mr-2">
              <Button
                name="d1"
                id="d1"
                color="secondary"
                outline
                onClick={this.handleClick_districtFilter}
                active={districtFilter === "d1"}
              >
                D1
              </Button>
              <Button
                name="d2"
                id="d2"
                color="secondary"
                outline
                onClick={this.handleClick_districtFilter}
                active={districtFilter === "d2"}
              >
                D2
              </Button>
              <Button
                name="d3"
                id="d3"
                color="secondary"
                outline
                onClick={this.handleClick_districtFilter}
                active={districtFilter === "d3"}
              >
                D3
              </Button>
              <Button
                name="d4"
                id="d4"
                color="secondary"
                outline
                onClick={this.handleClick_districtFilter}
                active={districtFilter === "d4"}
              >
                D4
              </Button>
              <Button
                name="d5"
                id="d5"
                color="secondary"
                outline
                onClick={this.handleClick_districtFilter}
                active={districtFilter === "d5"}
              >
                D5
              </Button>
              <Button
                name="d6"
                id="d6"
                color="secondary"
                outline
                onClick={this.handleClick_districtFilter}
                active={districtFilter === "d6"}
              >
                D6
              </Button>
              <Button
                name="d7"
                id="d7"
                color="secondary"
                outline
                onClick={this.handleClick_districtFilter}
                active={districtFilter === "d7"}
              >
                D7
              </Button>
              <Button
                name="d8"
                id="d8"
                color="secondary"
                outline
                onClick={this.handleClick_districtFilter}
                active={districtFilter === "d8"}
              >
                D8
              </Button>
              <Button
                name="d9"
                id="d9"
                color="secondary"
                outline
                onClick={this.handleClick_districtFilter}
                active={districtFilter === "d9"}
              >
                D9
              </Button>
              <Button
                name="d10"
                id="d10"
                color="secondary"
                outline
                onClick={this.handleClick_districtFilter}
                active={districtFilter === "d10"}
              >
                D10
              </Button>
              <Button
                name="d11"
                id="d11"
                color="secondary"
                outline
                onClick={this.handleClick_districtFilter}
                active={districtFilter === "d11"}
              >
                D11
              </Button>
              <Button
                name="d12"
                id="d12"
                color="secondary"
                outline
                onClick={this.handleClick_districtFilter}
                active={districtFilter === "d12"}
              >
                D12
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      sortColumn,
      districtFilter,
      eaFilter,
      statusFilter,
      myProjFilter,
      showAlert_addToProDMS,
      showAlert_projNotAvail,
      showAlert_contactDistAdmin,
    } = this.state;
    const { openTabs, tab } = this.props;
    const isHomeTab = Array.isArray(openTabs) && openTabs[0] && tab.tabId == openTabs[0].tabId
    const myProjFilterHome = isHomeTab ? true : this.state.myProjFilter;
    // const { fetching } = this.props;
    const data = this.getData({myProjFilter: myProjFilterHome});
    return (
      <React.Fragment>
        {isHomeTab && this.props.user ? (
          <>
          <TitleBar titleText={"Your Assigned Projects"} />
            <div className="card m-2">
              <div className="card-body p-2">
                <div className="form-inline mb-2">
                  <div className="col-sm-2 px-0 mr-2">
                    <Select
                      name="statusFilter"
                      id="statusFilter"
                      value={statusFilter}
                      options={this.statusOptions}
                      onChange={this.handleChange_selectFilter("statusFilter")}
                      isSearchable={false}
                      placeholder="Filter by Status"
                    />
                  </div>
                  <button
                    type="button"
                    name="clearFilters"
                    id="clearFilters"
                    className="btn btn-secondary ml-2"
                    onClick={this.handleClick_clearFilters}
                  >
                    Clear
                  </button>
                </div>
                <Table
                  className="table table-hover"
                  data={data}
                  idPropName="projectId"
                  columns={this.columns.filter((_, idx) => idx !==4)}
                  /*
                  columns indexes adjusted for the Favorites button
                  columns={this.columns.filter((_, idx) => idx !==4 && idx !==7)}
                  */
                  sortColumn={sortColumn}
                  onSort={this.handleSort}
                  handleClick_tr={this.handleClick_projectListTr}
                />
              </div>
            </div>
          </>
        ) : !isHomeTab ? (
          <>
        <TitleBar titleText={"Project List"} />
        {this.renderFilters()}
        <div className="card m-2">
          <div className="card-body p-2">
            <div className="form-inline mb-2">
              <div className="input-group mr-2">
                <div className="input-group-prepend">
                  <span className="input-group-text bg-lightgray">
                    EA
                    <FontAwesomeIcon icon="search" className="fa-fw ml-1 text-muted" />
                  </span>
                </div>
                <input
                  name="eaFilter"
                  id="eaFilter"
                  className="form-control"
                  value={eaFilter}
                  onChange={this.handleChange_stringFilter}
                  disabled={!districtFilter}
                />
              </div>
              <div className="col-sm-2 px-0 mr-2">
                <Select
                  name="statusFilter"
                  id="statusFilter"
                  value={statusFilter}
                  options={this.statusOptions}
                  onChange={this.handleChange_selectFilter("statusFilter")}
                  isSearchable={false}
                  placeholder="Filter by Status"
                  isDisabled={!districtFilter}
                />
              </div>
              <Button
                name="myProjFilter"
                id="myProjFilter"
                color="primary"
                className="mr-2"
                outline
                onClick={this.handleClick_myProjFilter}
                active={myProjFilter}
                disabled={!districtFilter}
              >
                My Projects
              </Button>
              <button
                type="button"
                name="clearFilters"
                id="clearFilters"
                className="btn btn-secondary ml-2"
                onClick={this.handleClick_clearFilters}
              >
                Clear
              </button>
            </div>
            <Table
              className="table table-hover"
              data={data}
              idPropName="projectId"
                  columns={this.columns.filter((_, idx) => idx !==5 && idx !==6)}
                  /*
                  columns indexes adjusted for the Favorites button
                  columns={this.columns.filter((_, idx) => idx !==0 && idx !==1 && idx !==2 && idx !==8)}
                  */
                  sortColumn={sortColumn}
              onSort={this.handleSort}
              handleClick_tr={this.handleClick_projectListTr}
            />
          </div>
        </div>
        <AlertModal
          alertTitle="Add to ProDMS"
          alertTitleClass="bg-info text-white"
          alertTitleIcon="question-circle"
          alertText={"Add this project for use in ProDMS?"}
          acceptCaption={"Yes"}
          acceptClass={"primary"}
          provideReject={true}
          rejectCaption={"No"}
          rejectClass={"secondary"}
          handleAlertAction={this.handleAlert_addToProDMS}
          toggleAlertModal={this.toggleAlert_addToProDMS}
          showAlertModal={showAlert_addToProDMS}
        />
        <AlertModal
          alertTitle="Project Not Available"
          alertTitleClass="bg-warning"
          alertTitleIcon="exclamation-triangle"
          alertText={
            `Access to this project is closed in the current environment.\n` +
            `If this project is included in your district's ProDMS Implementation Program, ` +
            `it can be accessed only from https://prodms.dot.ca.gov.\n` +
            `Please contact your district's ProDMS Administrator for more info.`
          }
          acceptCaption={"OK"}
          acceptClass={"secondary"}
          provideReject={false}
          handleAlertAction={this.toggleAlert_projNotAvail}
          toggleAlertModal={this.toggleAlert_projNotAvail}
          showAlertModal={showAlert_projNotAvail}
        />
        <AlertModal
          alertTitle="Project Not in ProDMS"
          alertTitleClass="bg-warning"
          alertTitleIcon="exclamation-triangle"
          alertText={
            `This project is currently not in ProDMS.\n` +
            `Please contact your district's ProDMS Administrator for more info.`
          }
          acceptCaption={"OK"}
          acceptClass={"secondary"}
          provideReject={false}
          handleAlertAction={this.toggleAlert_contactDistAdmin}
          toggleAlertModal={this.toggleAlert_contactDistAdmin}
          showAlertModal={showAlert_contactDistAdmin}
        />
          </>
        ) : null
        } 
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  appSettings: state.appSettings,
  user: state.authentication.user,
  openTabs: state.mainTabs.openTabs,
  projectList: state.projects.openProjectLists[ownProps.tab.tabId] || null,
  //currUserProjects: state.projects.assignedProjectsForUser,
  currUserProjects: state.authentication.user?.projectRoles || [],
  authentication: state.authentication,
  projRoleOptions: state.projects.projRoles
    ? state.projects.projRoles.map((pr) => ({
        value: pr.projectRoleId,
        label: pr.description,
      }))
    : [],
  fetching:
    state.adr.fetching ||
    state.adr.creating ||
    state.adr.saving ||
    state.users.fetching ||
    state.users.registering ||
    state.authentication.loggingIn ||
    state.feederLists.fetching ||
    state.projects.creating ||
    state.projects.fetching ||
    state.projects.saving ||
    state.reports.creating ||
    state.reports.fetching,
});

export default connect(mapStateToProps)(ProjList);
